import { useSetModal } from "@/shared/atoms/useModal";
import useCartItemKitchenPatch from "@/shared/mutations/orders/useCartItemKitchenPatch";
import useScreensQuery from "@/shared/queries/screens/useScreensQuery";
import useLiveOrdersRefetch from "@/shared/v2/hooks/useLiveOrdersRefetch";
import { CartContent, OrderV2, Screen } from "@/shared/v2/queries/interfacesV2";
import { useTranslation } from "react-i18next";
import Spinner from "../Spinner/Spinner";

const OrderSelect = ({
  item,
  order,
  screens,
}: {
  item: CartContent;
  order: OrderV2;
  screens: Screen[];
}) => {
  const refetch = useLiveOrdersRefetch();
  const setModal = useSetModal();
  const { t } = useTranslation("");
  const update = useCartItemKitchenPatch(order.order_information.branch_id);
  return (
    <div className="flex items-center gap-4">
      <select
        value={item?.kitchen_screen_id || -1}
        onChange={(e) =>
          update
            .mutateAsync({
              orderId: order.order_information.item_id,
              cartUsageItemId: item.cart_usage_item_id,
              kitchenScreenId: e.target.value,
            })
            .then(() => {
              refetch();
              setModal("");
            })
        }
        className="outline-0 py-1 px-2 border rounded-md min-w-30"
      >
        {item?.kitchen_screen_id === undefined && (
          <option defaultChecked value={-1}>
            {t("noKitchenscreen")}
          </option>
        )}
        {screens?.map((screen) => (
          <option value={screen.item_id} key={screen.item_id}>
            {screen.name}
          </option>
        ))}
      </select>
      {update.isPending && <Spinner size="0.2rem" />}
    </div>
  );
};

export default OrderSelect;
